import { render } from "./AppFormField.vue?vue&type=template&id=c82a796e&scoped=true"
import script from "./AppFormField.vue?vue&type=script&lang=js"
export * from "./AppFormField.vue?vue&type=script&lang=js"

import "./AppFormField.vue?vue&type=style&index=0&id=c82a796e&scoped=true&lang=css"

import exportComponent from "/tmp/build_61b3eac7/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82a796e"]])

export default __exports__